import { render, staticRenderFns } from "./Windows.vue?vue&type=template&id=492bf420&scoped=true&"
import script from "./Windows.vue?vue&type=script&lang=js&"
export * from "./Windows.vue?vue&type=script&lang=js&"
import style0 from "./Windows.vue?vue&type=style&index=0&id=492bf420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492bf420",
  null
  
)

export default component.exports